import { Box, MantineColor, MantineStyleProp, Tooltip } from '@mantine/core'
import classes from './Dot.module.css'

export interface DotProps {
  color: MantineColor
  style?: MantineStyleProp
  tooltip?: string
}

export const Dot = (props: DotProps) => {
  const { color, tooltip, style = {} } = props

  return tooltip ? (
    <Tooltip label={tooltip}>
      <Box className={classes.Dot} bg={color} style={style} />
    </Tooltip>
  ) : (
    <Box className={classes.Dot} bg={color} style={style} />
  )
}
